<template>
    <md-report-layout :header-buttons="headerButtons" :loading="loading" :loading-text="loadingText" ref="reportLayout">
        <template v-slot:header-left>
            <md-date-select :init-start="rangeStart" :init-end="rangeEnd" @change="dateRangeChanged"
                            display-mode="header" />
        </template>
        <template v-slot:employee-list>
            <ReportConfig :options="reportConfigData" @configChanged="onReportConfigChange" />
        </template>
        <template v-slot:report-settings>
            <div style="text-align:left; font-weight:bold; font-size: 20px;">
                {{ $t('report.main.reportList') }}
            </div>
            <div class="reports-list">
                <datatablesimple :state="reportState" />
            </div>
            <div v-if="reports.length == 0">
                {{ $t('report.main.noReportsCreated') }}
            </div>
        </template>
        <template v-slot:button-bar v-if="creatingReport">
      <span v-if="creatingReport">
        <i class="fas fa-circle-notch fa-spin"></i>
        {{ $t('report.main.reportCreating') }}
      </span>
        </template>
    </md-report-layout>
</template>

<script>
import moment from 'moment';
import MdReportLayout from '@/components/reportcontext/ReportLayout';
import MdDateSelect from '@/components/uicomponents/md-date-select';
import { reportMixin } from '@/components/reportcontext/report-mixin';
import ReportConfig from '@/shared/components/ReportConfig.vue';

export default {
  name: 'reportovertimeoverview',
  components: {
      ReportConfig,
    MdReportLayout,
    MdDateSelect,
  },
  mixins: [ reportMixin ],
  data() {
    return {
      loadingText: this.$t('report.main.loadX', [this.$t('report.main.overtimeOverview')]),
      showOnlyActiveEmployees: true,
    }
  },
  created() {
    
  },
  mounted() {
    if (this.$store.state.jwt !== undefined && this.$store.state.storeId !== undefined) {

      this.refresh();

      // NOTE:
      // demo code for updateReportConfig
      // this.updateReportConfig('test', 1);
      // this.updateReportConfig('testObj', {});
      // this.updateReportConfig(['testObj', 'key'], 1);
      // creates a new deeply nested config entry
      // this.updateReportConfig(['testObj', 'key2', 'newNested', 'newNested2'], 1);
    }
  },
  computed: {
    headerButtons() {
      let helperLinks = [];
      let buttons = [
        {
          classes: 'add-employeetype',
          type: 'block gray',
          disabled: false,
          icon: 'fa-th-list',
          click: ($event) => {
          },
          show: true,
          tooltip: this.$t('report.main.overtimeOverview'),
          helperText: this.$t('report.main.overtimeOverviewHelp'),
          //externalUrl: "https://meindienstplan.atlassian.net/servicedesk/customer/kb/view/1134428161"
        },
        {
          type: 'block green',
          disabled: this.creatingReport,
          icon: this.creatingReport ? 'fa-redo' : 'fa-file-check',
          click: ($event) => {
            this.createReportProxy();
          },
          show: true,
          tooltip: this.$t('global.ui.createX', [this.$t('roster.view.report')]),
        },
      ];
      let state = {
        buttons: buttons,
        helperLinks: helperLinks,
        showListIconAlways: true,
      };

      state.helperLinks = [
        {
            icon: "fa-video",
            title: this.$t('store.structure.watchTrainingVideo'),
            helperText: this.$t('store.structure.watchTrainingVideoHelp'),
            externalUrl: "https://www.youtube.com/watch_popup?v=BePh4xNJvsY",
            externalLabel: this.$t('global.ui.trainingVideoX', [this.$t('global.menubar.reports')]),
            cancelLabel: this.$t('global.ui.close'),
        },
        {
          title:  this.$t('store.structure.getSupport'),
          helperText: this.$t('store.structure.getSupportHelp'),
          externalUrl: 'https://meindienstplan.atlassian.net/servicedesk/customer/portal/1/group/2/create/15',
          externalLabel:  this.$t('store.structure.getSupportLabel'),
          cancelLabel: this.$t('global.ui.close'),
        },
      ];
      return state;
    },
      reportState() {
          if (this.reports === undefined || this.reports.length < 1) {
              return null;
          }

          let data = Object.values(this.reports);

          let columns = {
              name: this.$t('report.main.documentName'),
              format: this.$t('report.main.fileFormat'),
              creationDate: this.$t('global.menubar.sortOptionCreationDate'),
              comment: this.$t('global.general.comment'),
              actions: ' ',
          };

          let state = this.$helpers.GetDataTableStateFromKeyLabelObject(columns, data);

          this.$helpers.buildHeaderMapLabel(state.headerMap, 'name');
          this.$helpers.buildHeaderMapLabel(state.headerMap, 'format');
          this.$helpers.buildHeaderMapLabel(state.headerMap, 'creationDate');
          this.$helpers.buildHeaderMapLabel(state.headerMap, 'comment');
          this.$helpers.buildHeaderMapLabel(state.headerMap, 'actions');
          state.headerMap.actions.componentStateBuilders = [
              (data) => {
                  return {
                      componentType: 'buttonc',
                      tooltip: () => {
                          return this.$t('global.ui.open');
                      },
                      type: 'button square rounded no-border',
                      icon: 'fas fa-envelope-open',
                      customEvents: {
                          click: () => {
                              this.openReportUrl(data.url);
                          },
                      },
                  };
              },
              (data) => {
                  return {
                      componentType: 'buttonc',
                      tooltip: () => {
                          return this.$t('global.general.download');
                      },
                      type: 'button square rounded no-border green',
                      icon: 'fas fa-download',
                      customEvents: {
                          click: () => {
                              this.downloadReport(data);
                          },
                      },
                  };
              },
              (data) => {
                  return {
                      componentType: 'buttonc',
                      tooltip: () => {
                          return this.$t('global.ui.delete');
                      },
                      type: 'button square rounded no-border red',
                      icon: 'fas fa-trash',
                      customEvents: {
                          click: () => {
                              this.openDeleteReportPopup(data);
                          },
                      },
                  };
              },
              // open report openReport
          ];

          let entries = Object.entries(state.headerMap);

          entries[0][1].key = 'name';
          entries[0][1].width = '30%';
          entries[1][1].key = 'format';
          entries[1][1].width = '10%';
          entries[2][1].key = 'creationDate';
          entries[2][1].width = '20%';
          entries[3][1].key = 'comment';
          entries[3][1].width = '25%';
          entries[4][1].key = 'actions';
          entries[4][1].width = '15%';

          state.headerStyles = { fontSize: '10px', position: 'sticky', top: 0, zIndex: 10 };
          state.heightSubRow = 'fit-content';
          state.rowStylesCollapsed = this.strippedRowStyle();
          state.alwaysUnfold = false;

          return state;
      },
  },
  watch: {
    storeId(newVal, oldVal) {
      this.refresh(true);
    },
    rangeStart() {
      this.updateReportConfig('reportname', this.getReportName());
    },
  },
  // methods that implement data (BUSINESS) logic. (https://en.wikipedia.org/wiki/Business_logic)
  methods: {
    getReportName() {
      return this.rangeMode === 'monthlyRange'
          ? this.$t('report.main.overtimeOverview') + ' ' + moment(this.rangeStart).locale(this.$i18n.locale).format('MMMM YYYY')
          : this.$t('report.main.overtimeOverview') + ' ' + this.$t('report.main.xTillY', [moment(this.rangeStart).locale(this.$i18n.locale).format('DD.MM.YYYY'), moment(this.rangeEnd).locale(this.$i18n.locale).format('DD.MM.YYYY')]);

    },
    async refresh(force = false) {
      this.loading = true;
      this.updateReportConfig('reportname', this.getReportName());

      try {
        await Promise.all([
          this.$helpers.GetExportSettingsMap(force),
          this.loadReports('OVERTIMEOVERVIEW'),
        ]);
      } catch (error) {
        console.error(error);
      } finally {
        this.generateReportConfigOpts();
        
        // console.log(this.getReportConfigValue('reportname'));
        // reportConfig can be loaded after generating the options, as reportConfig does not overwrite the options
        this.reportConfig = this.loadReportConfig();
        this.updateReportConfig('reportname', this.getReportName());
        
        this.loading = false;
      }
    },

    generateReportConfigOpts() {
      let disabled = !this.CheckEnableConfigEdit
      let specialDisabled = !this.CheckEnableConfigSpecialEdit
      const nameSection = this.createReportConfigSection(this.$t('report.main.documentName'), true);
      this.addTextConfigOption(nameSection, 'reportname', this.$t('report.main.enterDocumentName'), this.getReportName(), true);

      const commentSection = this.createReportConfigSection(this.$t('global.general.comment'));
      this.addTextConfigOption(commentSection, 'reportcomment', this.$t('report.main.enterComment'));

      const headerFormatSection = this.createReportConfigSection(this.$t('report.main.header'), false, specialDisabled);
      this.addSelectConfigOption(headerFormatSection, 'settingDateFormat', [
        this.addSelectableValue('DD.MM.YYYY', 'DD.MM.YYYY', true),
        this.addSelectableValue('YYYY-MM-DD', 'YYYY-MM-DD'),
      ]);
      this.addSelectConfigOption(headerFormatSection, 'headerShowQr', [
        this.addSelectableValue(this.$t('global.ui.showX', [this.$t('report.main.qrCode')]), true),
        this.addSelectableValue(this.$t('global.ui.hideX', [this.$t('report.main.qrCode')]), false, true),
      ]);

    },

    async createReportProxy() {
      await this.recalculatePreviousMonthWorkbalances();
      await this.generateReport();
    },
    async recalculatePreviousMonthWorkbalances() {
      const employeeIds = this.employees.filter(({ selected }) => selected).map(({ id }) => id);
      const reportYear = this.rangeStart.year();
      const repMonth = this.rangeStart.month();

      const yearDate = this.$helpers.getMomentFromValuesUTC(reportYear, Math.max(0, repMonth), 1).add(1, 'months');

      const reportMonth = this.$helpers.getMomentFromValuesUTC(reportYear, Math.max(0, repMonth), 1)

      const oldLoadingText = this.loadingText.slice();

      this.loading = true;
      this.loadingText = this.$t('pref.main.updateMonthEndClosings');

      let returnState;
      try {
        const wbc = this.$refs.reportLayout.$refs.employeeworkbalancecreation;
        await wbc.recalculatePastInvalid(yearDate, employeeIds, reportMonth)
        returnState = true;
      } catch (error) {
        console.error(error);
        returnState = false;
      } finally {
        this.loading = false;
        this.loadingText = oldLoadingText;
      }
      return returnState;
    },

    async generateReport() {
      this.creatingReport = true;

      const dateFormats = {
        'DD.MM.YYYY': 'dmY',
        'YYYY-MM-DD': 'Ymd',
      };
      const dateFormat = dateFormats[this.reportConfig.settingDateFormat] || 'dmY';

      const name = this.reportConfig.reportname;
      const comment = this.reportConfig.reportcomment;
      const config = {
        'year': this.rangeStart.year(),
        'month': this.rangeStart.month() + 1,
        'headerDateFormat': dateFormat,
        'headerShowQr': this.reportConfig.headerShowQr,
        'documentComment': comment,
      };

      await this.createReport('OVERTIMEOVERVIEW', name, comment, config);
    },

  },
}
</script>

<style scoped>
</style>
